import React from 'react';
import { useState } from 'react';
import Odd from '../../common/Odd';
import { LIST_BETS_HANDICAP_TYPES, INFO_AGG_NEED_TO_BE_AGG } from '../../data/constants';
import { classIf, getBetDescription, aggregateBetsForPlayer, filterSearchResults, sortScorers } from '../../data/utils';
import { xs_languageCode } from '../..';
import { splitHandicap } from '../../data/splitHandicap';
import { getLabel } from '../../InitData';

function ListbetsLayoutContent(props) {
    // TODO verificare perché hasOdds = true ma bet.odds.length è 0
    let bets = props.bets.filter(bet => bet.odds.length > 0);
    const aggrBetsForPlayer = bets.length > 0 && INFO_AGG_NEED_TO_BE_AGG.includes(bets[0].tipoHandicap);
    if(aggrBetsForPlayer){
        // restore the bets array: I'll get an array with one bet for player, and many odds taken from all the originary bets sharing the same player.
    	// es: Ronaldo scores 1 goal -> yes, Ronaldo scores 2 goals -> yes, then I'll get Ronaldo -> score 1 goal yes, score 2 goals yes 
    	bets = aggregateBetsForPlayer(bets, bets[0].tipoHandicap);
    }

    let isScorerMarket = false;
    try {
        const dia = bets[0].dia;
        const regex = /(?<scorer>.+?)\s*\(\s*(?<team>.+?)\s*\)/;
        isScorerMarket = regex.test(dia);
    } catch (e) {}

    if (isScorerMarket) {
        const b = bets[0].odds[0];
        bets = sortScorers(bets, b.team1, b.team2);
    } else if (bets[0]?.dia?.length > 0 && bets[0].odds.length === 1) {
        bets.sort((a, b) => a.odds[0].rawValue - b.odds[0].rawValue);
    }
    
    const [selectedBet, setSelectedBet] = useState(bets[0]);
    const [selectedOdd, setSelectedOdd] = useState(selectedBet.odds[0]);
    const [search, setSearch] = useState(null);

    function handleChange(event) {
        setSearch(event.target.value);
    }

    function selectBet(bet) {
        setSelectedBet(bet);
        setSelectedOdd(bet.odds[0]);
    }

    let betDesc = getBetDescription(selectedBet, false);
    const splittedHandicap = splitHandicap(selectedBet.handicap, selectedBet.tipoHandicap, [], null, xs_languageCode);
	if(splittedHandicap.infoCalcolate !== 2){
		betDesc = betDesc.replace(selectedBet.dia, '');
	}

    let filteredBets = bets;
    if (search != null) {
        filteredBets = filterSearchResults(bets, search, 'BET', function(bet) {
            return bet.dia;
        });
    }
    const infoAggDesc = selectedBet.dia;

    return (
        <>
            <div className="gridInterernaQuotazioni">
                <button className={"dropdown-toggle text-uppercase bg-transparent bordo-tondo mx-1 bottone-quota-largo" + classIf(bets.length <= 1, 'dropdown-toggle-no-arrow')} type="button" data-toggle="dropdown">
                    <span className="uo-selezionato tinytext">{infoAggDesc}</span>
                </button>
                <div className="dropdown-menu">
                    <div className="ricerca-fastbet-in-quote">
                        <input className="input-personalizzato-fastbet-ricerca" type="text" id="ric-fastbet-in-quota" placeholder={getLabel('general.ricerca')} onChange={handleChange} autoFocus={true} autoComplete="off" />
                    </div>
                    {filteredBets.map(bet => {
                        const iad = bet.dia;
                        return (
                            <a key={bet.uniqueId} className={"dropdown-item" + classIf(selectedBet.uniqueId === bet.uniqueId, 'selezionata')} onClick={() => selectBet(bet)}>
                                {iad}
                            </a>
                        );
                    })}
                </div>
            </div>
            <div className="gridInterernaQuotazioni">
                <button className={"dropdown-toggle text-uppercase bg-transparent bordo-tondo mx-1 bottone-quota-largo" + classIf(selectedBet.odds.length <= 1, 'dropdown-toggle-no-arrow')} type="button" data-toggle="dropdown">
                    <span className="uo-selezionato tinytext">
                    	{
                    		aggrBetsForPlayer? selectedOdd.descForBetsAggregate : (betDesc + (selectedOdd.desc && selectedOdd.desc.length > 0? (' (' + selectedOdd.desc + ')') : '' ))
                    	}
                    </span>
                </button>
                <div className="dropdown-menu">
                    {selectedBet.odds.map(odd => {
                        let oddDesc = '';
                        if (aggrBetsForPlayer) {
                            oddDesc = odd.descForBetsAggregate;
                        } else {
                            oddDesc = `(${betDesc})${odd.desc?.length > 0 ?` (${odd.desc})` : ''})`;
                        }

                        const id = `${selectedBet.cs}_${odd.betData.handicap}_${odd.id}`;
                        return (
                            <a key={id} className={"dropdown-item" + classIf(selectedOdd.id === odd.id, 'selezionata')} onClick={() => setSelectedOdd(odd)}>
                                {oddDesc}	
                            </a>
                        );
                    })}
                </div>
            </div>
            <Odd {...selectedOdd} />
        </>
    );
}

export default function ListBetLayout(props) {
    const filteredBets = [];
    props.betsById.forEach(bets => {
        bets.forEach(b => {
            if (LIST_BETS_HANDICAP_TYPES.includes(b.tipoHandicap) && b.odds.length > 0) {
                filteredBets.push(b);
            }
        })
    });

    if (filteredBets.length === 0) {
        return null;
    }

    return <ListbetsLayoutContent key={filteredBets[0].aggId} bets={filteredBets} />;
}
